import {
  a,
  detailsBig,
  detailsSmall,
  h3,
  paragraph,
} from "@/styles/typography";
import styled from "styled-components";

const Card = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  max-width: 415px;
  height: 100%;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;

  .gatsby-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
    max-width: 100vw;
    height: fit-content;
    min-height: 420px;
  }
  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Category = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  position: absolute;
  top: 0;
  z-index: 2;
`;

const TextWrapper = styled.div`
  background-color: transparent;
  padding: 20px;
  height: 75%;
  z-index: 2;

  @media ${({ theme }) => theme.breakpoints.sm} {
    min-height: 320px;
  }
`;

const Date = styled(detailsSmall)`
  color: ${({ theme }) => theme.textColors.secondary};
  margin: 10px 0;
  text-transform: uppercase;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin: 0 0 10px 0;
  }
`;

const Title = styled(h3)`
  color: ${({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 125%;
`;

const Line = styled.div`
  border-bottom: 2px solid ${({ theme }) => theme.textColors.secondary};
  width: 200px;
  height: 0px;
  margin: 10px 0 18px 0;
`;

const PWrapper = styled.div`
  max-height: 135px;
  margin-bottom: 50px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    max-height: 72px;
    overflow: hidden;
  }
`;

const Paragraph = styled(paragraph)`
  color: ${({ theme }) => theme.textColors.secondary};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const DetailsBig = styled(detailsBig)`
  color: ${({ theme }) => theme.colors.primary};
  padding: 10px 30px;
  margin: 20px 20px 0 0;
  background-color: #fff;
  transition: all 0.3s ease-out;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 16px 16px 0 0;
    padding: 8px 24px;
    font-size: 14px;
    line-height: normal;
  }
`;

const ArrowWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 35px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    bottom: 0px;
    right: 23px;
  }
`;

const HoverWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.65);
  height: 75%;
  width: 100%;
  transition: all 0.3s ease-out;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;

  @media ${({ theme }) => theme.breakpoints.sm} {
    min-height: 340px;
  }
`;

const LinkWrapper = styled(a)`
  text-decoration: none;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      ${HoverWrapper} {
        height: 100%;
      }
      ${DetailsBig} {
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.textColors.secondary};
      }
    }
  }
`;

const S = {
  Card,
  Image,
  Category,
  TextWrapper,
  Date,
  Title,
  Line,
  PWrapper,
  Paragraph,
  DetailsBig,
  ArrowWrapper,
  LinkWrapper,
  HoverWrapper,
};

export default S;
